import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Homey',
      href: '/de/Software/Home_Automation/Athom_Homey/',
    },
    {
      text: 'FHEM',
      href: '/de/Software/Home_Automation/FHEM/',
    },
    {
      text: 'Home Assistant',
      href: '/de/Software/Home_Automation/Home_Assistant/',
    },
    {
      text: 'Homematic',
      href: '/de/Software/Home_Automation/Homematic/',
    },
    {
      text: 'homee',
      href: '/de/Software/Home_Automation/Homee/',
    },
    {
      text: 'IOBroker',
      href: '/de/Software/Home_Automation/IOBroker/',
    },
    {
      text: 'Loxone',
      href: '/de/Software/Home_Automation/Loxone/',
    },
    {
      text: 'Node-RED',
      href: '/de/Software/Home_Automation/Node-RED/',
    },
    {
      text: 'OpenHAB',
      href: '/de/Software/Home_Automation/OpenHAB2/',
    },
    {
      text: '◄ Smarthome',
      href: '/de/Software/Home_Automation/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}